module.exports = __webpack_public_path__ + "static/home_02-616dc3d7bcc43f4a4d044c3f46307ce1.webp";